import {
  ProposalOwner,
  ProposedActionStatus,
  SuitabilityReportProposedAction,
} from '../chat/types';

type SettledDecision = {
  status: ProposedActionStatus;
  failureReason: string | null;
  owner: ProposalOwner;
};

/**
 * What the server holds for a suitability report proposal after a decision came back as a 409.
 * The first click may have landed with its response lost, or another tab may have decided it, so
 * the card shows the real outcome rather than assuming the proposal expired. 'in-progress' when
 * the proposal is still pending, which means another decision holds the claim; null when the
 * outcome cannot be read.
 */
export async function settledSuitabilityDecision(
  fetchProposal: (proposalId: string) => Promise<SuitabilityReportProposedAction | null>,
  proposalId: string,
): Promise<SettledDecision | 'in-progress' | null> {
  const proposal = await fetchProposal(proposalId).catch(() => null);
  if (!proposal?.status) return null;
  if (proposal.status === 'PENDING') return 'in-progress';
  return {
    status: proposal.status,
    failureReason: proposal.failureReason ?? null,
    owner: { clientId: proposal.clientId, familyId: proposal.familyId },
  };
}
